import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTachometerAlt,
  faUserCircle,
  faBell,
  faSignOutAlt,
  faChartBar,
  faChevronDown,
  faBars,
  faTimes,
  faIdCard
} from '@fortawesome/free-solid-svg-icons';

import './TenantSidebar.css';

const TenantSidebar = () => {
  const [isReportOpen, setIsReportOpen] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [loggedUser, setLoggedUser] = useState(null);
  
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setLoggedUser(JSON.parse(storedUser));
    }
  }, []);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  const handleLogout = (e) => {
    e.preventDefault();
    localStorage.clear();
    navigate('/login');
  };

  const getNavLinkClass = (path) => {
    return location.pathname === path ? 'nav-item active' : 'nav-item';
  };

  return (
    <>
      {/* MOBILE TOGGLE BUTTON */}
      <button className="mobile-toggle" onClick={toggleSidebar} aria-label="Toggle Menu">
        <FontAwesomeIcon icon={isSidebarOpen ? faTimes : faBars} />
      </button>

      {/* SIDEBAR */}
      <aside className={`tenant-sidebar ${isSidebarOpen ? 'open' : ''}`}>
        
        {/* HEADER */}
        <div className="sidebar-header">
          <div className="logo-box">G</div>
          <div className="brand-text">
            <h3>GKM INVEST</h3>
            <span>Tenant Portal</span>
          </div>
        </div>

        {/* NAVIGATION */}
        <nav className="sidebar-content">
          <div className="nav-group">
            <span className="group-title">Main Menu</span>
            
            <Link to="/tenant" className={getNavLinkClass('/tenant')}>
              <FontAwesomeIcon icon={faTachometerAlt} className="nav-icon" />
              <span>Dashboard</span>
            </Link>

            <Link to="/tenant/profile" className={getNavLinkClass('/tenant/profile')}>
              <FontAwesomeIcon icon={faIdCard} className="nav-icon" />
              <span>My Profile</span>
            </Link>

            <Link to="/tenant/notification" className={getNavLinkClass('/tenant/notification')}>
              <FontAwesomeIcon icon={faBell} className="nav-icon" />
              <span>Notifications</span>
              <span className="sidebar-badge"></span>
            </Link>
          </div>

          <div className="nav-group">
            <span className="group-title">Personal Analytics</span>
            <div className={`nav-dropdown ${isReportOpen ? 'expanded' : ''}`}>
              <button 
                className="nav-item dropdown-trigger" 
                onClick={() => setIsReportOpen(!isReportOpen)}
              >
                <FontAwesomeIcon icon={faChartBar} className="nav-icon" />
                <span>Reports</span>
                <FontAwesomeIcon icon={faChevronDown} className="chevron" />
              </button>
              
              <div className="dropdown-menu">
                <Link to="/tenant/reports/monthly">Monthly Overview</Link>
                <Link to="/tenant/reports/billing">Billing History</Link>
              </div>
            </div>
          </div>
        </nav>

        {/* FOOTER / USER CARD */}
        <div className="sidebar-footer">
          <div className="user-mini-profile">
            <FontAwesomeIcon icon={faUserCircle} className="user-avatar" />
            <div className="user-info">
              <p className="user-name">{loggedUser?.name || "Guest Tenant"}</p>
              <p className="user-role">Resident</p>
            </div>
          </div>

          <button onClick={handleLogout} className="logout-btn">
            <FontAwesomeIcon icon={faSignOutAlt} />
            <span>Sign Out</span>
          </button>
        </div>
      </aside>

      {/* OVERLAY */}
      {isSidebarOpen && <div className="sidebar-overlay" onClick={toggleSidebar}></div>}
    </>
  );
};

export default TenantSidebar;